module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle3.png?c1b5bcbdc09743941bf6c34d9bc95b6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle3.png
// module id = 811
// module chunks = 0